import { ApiError } from '~/api/client'

// 어드민 인증은 knoka SSO 전용이다. 로그인/로그아웃은 서버사이드 OIDC 리다이렉트 흐름이라
// 프런트는 전체 페이지 이동만 하고(아래 URL 헬퍼), 세션 확인만 fetch로 한다.
//
// knoka 엔드포인트는 SPA 마운트(`/admin`)·Admin API(`/admin/api`)와 분리된 top-level
// `/api/auth/*`다. SPA base가 `/admin`이라 라우터 상대경로와 헷갈리지 않게 절대경로로 둔다.

/** knoka SSO 로그인 시작(전체 페이지 이동 대상). */
export const KNOKA_LOGIN_URL = '/api/auth/login'
/** knoka SSO 로그아웃(쿠키·세션 정리 + knoka end_session, 전체 페이지 이동 대상). */
export const KNOKA_LOGOUT_URL = '/api/auth/logout'
/** 세션 확인 엔드포인트. */
const KNOKA_ME_URL = '/api/auth/me'

/** GET /api/auth/me 응답 — 쿠키 세션의 현재 어드민 주체. */
export interface AdminMe {
    subject: string
    role: string
    email: string | null
}

/** GET /api/auth/me — 쿠키 세션을 확인한다. 미인증(401)/비어드민(403)은 ApiError로 던져진다. */
export async function getMe(): Promise<AdminMe> {
    const resp = await fetch(KNOKA_ME_URL, {
        method: 'GET',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
    })
    if (!resp.ok) {
        let code = 'ApiError'
        let message = `세션 확인이 실패했어요 (${resp.status}).`
        try {
            const body = (await resp.json()) as {
                code?: string
                message?: string
            }
            code = body.code ?? code
            message = body.message ?? message
        } catch {
            // JSON 파싱 실패 시 기본 메시지를 유지한다.
        }
        throw new ApiError(code, message, resp.status)
    }
    return (await resp.json()) as AdminMe
}
